import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import axios from 'axios'
const app = createApp(App)
// 配置axios
axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8'
//axios.defaults.baseURL = window.config.apiUrl // 使用你配置中的apiUrl
// 安装插件
app.use(router)
app.use(Vant)
app.use(store)

// 挂载应用
app.mount('#app')
//createApp(App).use(Vant).use(store).use(router).mount('#app');

